import { ChangeDetectionStrategy, Component, computed, inject } from '@angular/core';
import { ThemeService } from '@/core/services/theme/theme.service';
import { IconComponent } from '@/shared/components/icon/icon.component';
import { ButtonDirective } from '@/shared/directives/ui/button/button';

/** Bouton qui bascule entre le thème clair et le thème sombre. */
@Component({
  selector: 'app-theme-toggle',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [IconComponent, ButtonDirective],
  template: `
    <button
      appButton
      type="button"
      variant="ghost"
      size="icon"
      [attr.aria-label]="libelle()"
      [attr.aria-pressed]="sombre()"
      [title]="libelle()"
      (click)="theme.basculer()"
    >
      <app-icon [name]="sombre() ? 'sun' : 'moon'" [size]="18" aria-hidden="true" />
    </button>
  `,
})
export class ThemeToggleComponent {
  protected readonly theme = inject(ThemeService);

  readonly sombre = computed(() => this.theme.theme() === 'dark');
  readonly libelle = computed(() =>
    this.sombre() ? 'Passer au thème clair' : 'Passer au thème sombre',
  );
}
